import { render } from "./PromoTypeModal.vue?vue&type=template&id=2605e1c6&scoped=true"
import script from "./PromoTypeModal.vue?vue&type=script&lang=js"
export * from "./PromoTypeModal.vue?vue&type=script&lang=js"

import "./PromoTypeModal.vue?vue&type=style&index=0&id=2605e1c6&scoped=true&lang=css"

import exportComponent from "D:\\svn test\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2605e1c6"]])

export default __exports__